import axios from 'axios';
import React, { useState } from 'react';
import { ApiConnectionString } from '../../constants/ApiConntection';
import LoadingSpinner from '../../components/LoadingSpinner';
import { useAuthContext } from '../../hooks/useAuthContext';

export default function EmailNotification({emailNotification}) {
  const [emailNotifications, setEmailNotifications] = useState(emailNotification);
  const [isLoading,setIsLoading] = useState(false)
  const {user} = useAuthContext();

const handleToggle = async () => {
  setIsLoading(true);
  try {
    const emailNoteResponse = await axios.put(
      `${ApiConnectionString}/api/EmailNotification`,
      null,
      {
        headers: { Authorization: `Bearer ${user.token}` },
      }
    );

    if (emailNoteResponse.status === 200) {
      setEmailNotifications(emailNoteResponse.data);
    }
  } catch (error) {
    console.error('Failed to toggle email notification:', error);
    // Optionally show an error message to the user
  } finally {
    setIsLoading(false);
  }
};


if(isLoading){
  return(
    <div>
      <LoadingSpinner />
    </div>
  )
}else{
return (
  <div className="card shadow-sm mb-3 mx-3">
    <div className="card-body">
      <div className="d-flex align-items-center">
        <div className="form-check form-switch m-0">
          <input
            className="form-check-input"
            type="checkbox"
            id="emailNotifications"
            checked={emailNotifications}
            onChange={handleToggle}
          />
        </div>
        <label htmlFor="emailNotifications" className="fw-semibold ms-3 mb-0 mt-2">
          Email Notifications
        </label>
      </div>
      <p className="text-muted mt-2 mb-0 small">
        Toggle to receive updates and notifications via email for relevant account activity.
      </p>
    </div>
  </div>
);

}


}